<template>
  <svg
    width="779"
    height="365"
    viewBox="0 0 779 365"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M210.5 328V290.35H113V260.65L183.2 112H219.05L148.85 260.65H210.5V202.15H242.3V260.65H263.75V290.35H242.3V328H210.5ZM375.062 332.5C360.362 332.5 347.362 329.3 336.062 322.9C324.762 316.4 315.862 307.5 309.362 296.2C302.962 284.9 299.762 271.9 299.762 257.2V182.8C299.762 168.1 302.962 155.1 309.362 143.8C315.862 132.5 324.762 123.65 336.062 117.25C347.362 110.75 360.362 107.5 375.062 107.5C389.762 107.5 402.762 110.75 414.062 117.25C425.362 123.65 434.212 132.5 440.612 143.8C447.112 155.1 450.362 168.1 450.362 182.8V257.2C450.362 271.9 447.112 284.9 440.612 296.2C434.212 307.5 425.362 316.4 414.062 322.9C402.762 329.3 389.762 332.5 375.062 332.5ZM375.062 302.5C383.062 302.5 390.312 300.6 396.812 296.8C403.412 292.9 408.662 287.7 412.562 281.2C416.462 274.6 418.412 267.25 418.412 259.15V180.55C418.412 172.55 416.462 165.3 412.562 158.8C408.662 152.2 403.412 147 396.812 143.2C390.312 139.3 383.062 137.35 375.062 137.35C367.062 137.35 359.762 139.3 353.162 143.2C346.662 147 341.462 152.2 337.562 158.8C333.662 165.3 331.712 172.55 331.712 180.55V259.15C331.712 267.25 333.662 274.6 337.562 281.2C341.462 287.7 346.662 292.9 353.162 296.8C359.762 300.6 367.062 302.5 375.062 302.5ZM583.742 328V290.35H486.242V260.65L556.442 112H592.292L522.092 260.65H583.742V202.15H615.542V260.65H636.992V290.35H615.542V328H583.742Z"
      fill="#C4C4C4"
    />
    <path
      d="M676 139C707.48 139 733 113.48 733 81.9995C733 50.5193 707.48 24.9995 676 24.9995C644.52 24.9995 619 50.5193 619 81.9995C619 113.48 644.52 139 676 139Z"
      fill="#FF6347"
    />
    <path
      d="M690.494 64.5339C714.649 81.9362 733.404 101.973 744.207 120.28C749.609 129.435 753.011 138.136 754.12 145.845C755.228 153.55 754.043 160.231 750.316 165.404C746.589 170.578 740.627 173.817 732.967 175.205C725.304 176.594 715.973 176.123 705.579 173.897C684.793 169.446 659.849 158.001 635.694 140.599C611.539 123.197 592.785 103.16 581.981 84.8523C576.579 75.6977 573.178 66.9964 572.069 59.2879C570.96 51.5827 572.145 44.9017 575.872 39.7284C579.6 34.555 585.562 31.3156 593.221 29.9273C600.884 28.5385 610.215 29.01 620.609 31.2356C641.396 35.6864 666.339 47.1316 690.494 64.5339Z"
      fill="#E35F2F"
      stroke="#F4F6F5"
    />
    <path
      d="M676.859 82.6241C708.094 105.127 727.004 132.268 719.096 143.246C711.188 154.223 679.455 144.879 648.22 122.376C616.984 99.8728 598.074 72.7316 605.982 61.7544C613.891 50.7772 645.623 60.1209 676.859 82.6241Z"
      fill="white"
    />
    <path
      d="M696.5 34.9993C694 32.8326 686.6 28.7993 677 29.9993"
      stroke="white"
      stroke-width="5"
      stroke-linecap="round"
    />
    <path
      d="M668.58 31.1509C666.5 31.1509 665.5 31.4993 664 31.9993"
      stroke="white"
      stroke-width="5"
      stroke-linecap="round"
    />
    <path
      d="M684.5 356.998L720 140.999C725 133.499 710.5 113.499 706 108.498C700.673 102.578 692.945 94.5267 681 85.4979C673.592 79.898 664.681 73.6381 653 67.9983C649.111 66.1206 643.723 63.4741 642.5 62.9986C624.5 55.9981 614 55.4977 607.5 59.9984L0 356.998H684.5Z"
      fill="url(#paint0_linear_7107_52889)"
      fill-opacity="0.54"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7107_52889"
        x1="647"
        y1="67.9991"
        x2="592.5"
        y2="342.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D1FBEC" />
        <stop offset="1" stop-color="#D1FBEC" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
